import { groupBy } from 'lodash';
import { BasicPivotItem } from 'src/worker/pivotWorker.types';

function step(node: BasicPivotItem, acc: BasicPivotItem[]) {
  const children = node.children;

  if (children && children.length) {
    children.forEach((child) => step({ ...child }, acc));
  } else {
    acc.push(node);
  }
}

export function flattenToLeaves(treeData: BasicPivotItem[]) {
  const flat: BasicPivotItem[] = [];
  const firstIterable = Array.isArray(treeData) ? treeData : [treeData];
  firstIterable.forEach((item) => step(item, flat));
  return flat;
}

/** This function flattens the config items back to individual columns,
 * as we now group them in the ViewConfigurator */
export const flattenConfigItems = (items: any[]): any[] =>
  items.reduce<any[]>((acc, item) => {
    if (item.columns && item.columns.length) {
      // recurse into each child group
      return [...acc, ...flattenConfigItems(item.columns)];
    }
    return [...acc, item];
  }, []);

/** Finds dataIndex values shared by more than one column (flattened out of any groups) */
export const findDuplicateDataIndices = (items: any[]): string[] => {
  const groupedByDataIndex = groupBy(flattenConfigItems(items), 'dataIndex');
  return Object.entries(groupedByDataIndex)
    .filter(([_, group]) => group.length > 1)
    .map(([dataIndex]) => dataIndex);
};
